module.exports = __webpack_public_path__ + "static/media/02.b5968263.png";